module.exports = __webpack_public_path__ + "img/30.f34910ce.jpg";